import { Link } from "react-router-dom";
import { logout } from "api/auth";
import { DATA } from "index";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import forensicImg from "../../assets/img/forensic.jpg";
import argonReactImg from "../../assets/img/brand/argon-react.png";

// reactstrap components
import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Navbar,
  Nav,
  Container,
  Media,
  UncontrolledCollapse,
  Row,
  Col,
  NavItem,
  NavLink,
} from "reactstrap";

const IndexNavbar = (props) => {
  const { t, i18n } = useTranslation();
  const authSettings = window.APP_SETTINGS || {};
  const authenticationEnabled = Boolean(authSettings.AUTHENTICATION_ENABLED);
  const loginEnabled = Boolean(authSettings.LOGIN_ENABLED);
  const registrationEnabled = Boolean(authSettings.REGISTRATION_ENABLED);
  const hasAuthenticatedUser = Boolean(DATA && DATA.user && DATA.user.name);

  // Функция для смены языка и установки куки
  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    Cookies.set("language", lang, { expires: 365 }); // Установка куки на 1 год
  };

  return (
    <>
      <Navbar className="navbar-main navbar-expand-sm navbar-transparent py-2" expand="md" 
        style={{ boxShadow : "0 15px 35px rgba(50,50,93,.1)"}}>
        <Container>
          <Link className="navbar-brand mr-lg-5" to="/" onClick={() => {window.location.assign('/')}}>
            <img src={forensicImg} style={{width: '3vh', height: '3vh'}} alt="Forensic"/>
          </Link>

          <a className="link-black" href={"/"}>ForensCalc</a>

          <button className="navbar-toggler" id="navbar-collapse-main">
            <span className="navbar-toggler-icon"/>
          </button>
          <UncontrolledCollapse navbar toggler="#navbar-collapse-main">
            <div className="navbar-collapse-header d-md-none">
              <Row>
                <Col className="collapse-brand" xs="6">
                  <Link to="/">
                    <img
                        alt="..."
                        src={argonReactImg}
                    />
                  </Link>
                </Col>
                <Col className="collapse-close" xs="6">
                  <button className="navbar-toggler" id="navbar-collapse-main">
                    <span/>
                    <span/>
                  </button>
                </Col>
              </Row>
            </div>
            <Nav className="ml-auto" navbar>
              <NavItem>
                <NavLink className="nav-link-icon" to="/" onClick={() => {window.location.assign('/')}} tag={Link}>
                  <i className="ni ni-planet"/>
                  <span className="nav-link-inner--text">{t('Home')}</span>
                </NavLink>
              </NavItem>
              {!hasAuthenticatedUser ? null : (
                  <NavItem>
                    <NavLink className="nav-link-icon" to="/cabinet/index" tag={Link}>
                      <i className="ni ni-single-02"/>
                      <span className="nav-link-inner--text">{t('Cabinet')}</span>
                    </NavLink>
                  </NavItem>
              )}

              {!authenticationEnabled || !loginEnabled || hasAuthenticatedUser ? null : (
                  <NavItem>
                    <NavLink className="nav-link-icon" to="/auth/login" tag={Link}>
                      <i className="ni ni-key-25"/>
                      <span className="nav-link-inner--text">{t('login')}</span>
                    </NavLink>
                  </NavItem>
              )}

              {!authenticationEnabled || !registrationEnabled || hasAuthenticatedUser ? null : (
                  <NavItem>
                    <NavLink className="nav-link-icon" to="/auth/register" tag={Link}>
                      <i className="ni ni-circle-08"/>
                      <span className="nav-link-inner--text">{t('Register')}</span>
                    </NavLink>
                  </NavItem>
              )}

              {/* Выпадающее меню выбора языка */}
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret>
                  {t('Language')}
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem onClick={() => changeLanguage('en')}>
                    English
                  </DropdownItem>
                  <DropdownItem onClick={() => changeLanguage('ru')}>
                    Русский
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>

            </Nav>
          </UncontrolledCollapse>
        </Container>
      </Navbar>
    </>
  );
};

export default IndexNavbar;
